import { render, staticRenderFns } from "./Olympics.vue?vue&type=template&id=2a1c62ac&scoped=true&"
import script from "./Olympics.vue?vue&type=script&lang=js&"
export * from "./Olympics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c62ac",
  null
  
)

export default component.exports